import React from "react"

import Item from "./item"

import * as styles from "./itemsList.module.scss"

const ItemsList = ({ items, base, entity }) => {
  return (
    <ul className={styles.wrapper}>
      {items.map((item, i) => {
        const preview = entity && item.tabs[`${entity}ListingPreview`]
        const key = `${item.tabs.content.slug?.current || ""}${item.tabs.content.title}` + " " + i
        return <Item key={key} content={item.tabs.content} preview={preview} base={base} />
      })}
    </ul>
  )
}

export default ItemsList
